module.exports = __webpack_public_path__ + "img/ic-arrow-back.505d581e.svg";